import { useEffect, useState } from 'react'

import {
  createScenarioEntry,
  loadScenarioEntries,
  removeScenarioEntry,
  saveScenarioEntries,
  updateScenarioEntry,
} from './helpers'

const useScenarioCollection = ({ storeId, collection }) => {
  const [entries, setEntries] = useState(() => loadScenarioEntries(collection, storeId))

  useEffect(() => {
    saveScenarioEntries(collection, storeId, entries)
  }, [collection, storeId, entries])

  const add = () => setEntries(previousEntries => [...previousEntries, createScenarioEntry(collection)])

  const update = (entryId, changes) => {
    setEntries(previousEntries => updateScenarioEntry(previousEntries, entryId, changes))
  }

  const remove = entryId => setEntries(previousEntries => removeScenarioEntry(previousEntries, entryId))

  return { entries, add, update, remove }
}

export default useScenarioCollection
